export default "__VITE_ASSET__DlRSVN3K__"